// useMatches.js
import { useState, useCallback } from "react";
import { getMatches } from "@/services";

const useMatches = () => {
  const [matches, setMatches] = useState([]);
  const [totalMatches, setTotalMatches] = useState(0);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [isMatchesLoading, setIsMatchesLoading] = useState(false);

  const fetchMatches = useCallback(async (query = {}, { onSuccess } = {}) => {
    const { wantAdId, inventoryId, page = 1 } = query;
    if (!wantAdId && !inventoryId) return;

    console.log("DEBUG: useMatches fetchMatches called with:", query);
    setIsMatchesLoading(true);
    const queryWithScore = { minScore: 60, ...query };
    console.log("DEBUG: useMatches queryWithScore:", queryWithScore);

    try {
      const { data } = await getMatches(queryWithScore);

      const {
        data: payload = [],
        totalCount = 0,
        hasNextPage: nextPage = false,
      } = data || {};

      setMatches((prev) => (page > 1 ? [...prev, ...payload] : payload));
      setTotalMatches(totalCount);
      setHasNextPage(nextPage);
      onSuccess?.();
    } catch {
      if (page === 1) setMatches([]);
      setHasNextPage(false);
    } finally {
      setIsMatchesLoading(false);
    }
  }, []);

  return { matches, totalMatches, hasNextPage, isMatchesLoading, fetchMatches };
};

export default useMatches;
